module.exports = __webpack_public_path__ + "94624d703deb5e5e72dc12604ebc5541.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/news/temp.jpg
// module id = 399
// module chunks = 0